// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

import PageLayer from "@/Layouts/views/PageLayer";
import DepartmentalWashoutLayer from "@/Washouts/views/Layers/Departmental/DepartmentalWashoutLayer";
import actionsList from "@Constants/actionsList";
import { supportedSystemPositions } from "@/Common/helpers/Positions";

const positions = supportedSystemPositions();
const POSITION = positions.SERVICE.SERVICE_MANAGER;

export default function ServiceManagerWashout() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	const actions = {
		OVERRIDE_COMPENSATION: actionsList.OVERRIDE_SERVICE_MANAGER_COMPENSATION,
	};

	return (
		<PageLayer title={`${POSITION} Washouts`} icon={Icon}>
			<DepartmentalWashoutLayer position={POSITION} actions={actions} />
		</PageLayer>
	);
}
